// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__O7h30","candidates":"styles_candidates__wVZ22"};